module.exports = __webpack_public_path__ + "img/1.8e305f40.jpg";